import { useQuery } from '@tanstack/react-query';
import { chat } from '../api/methods';
export const chatKeys = {
    status: ['chat', 'status'],
};
export function useChatStatus(enabled = true) {
    return useQuery({
        queryKey: chatKeys.status,
        queryFn: () => chat.status(),
        enabled,
        retry: false,
        staleTime: 5 * 60_000,
    });
}
//# sourceMappingURL=useChat.js.map